var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.editorInitialized)?_c('div',{staticClass:"wrapper"},[_c('Editor',{attrs:{"init":_vm.init,"disabled":_vm.disabled},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }